import { Actions, ComparisonOperators, Rule } from '../../models/form/rule';

export const rulesMock2: Rule[] = [
  {
    id: 'rule-1',
    name: 'ma premiere rule',
    conditions: [
      [
        {
          id: 'condition-1',
          fieldId: 'check1',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
      ],
    ],
    targets: [
      {
        id: 'target-1',
        fieldId: 'text1',
        action: Actions.IsVisible,
      },
    ],
  },
  {
    id: 'rule-2',
    name: 'rule 3',
    conditions: [
      [
        {
          id: 'condition-2',
          fieldId: 'text-2',
          comparisonOperator: ComparisonOperators.IsEqual,
          value: 'salut',
        },
      ],
    ],
    targets: [
      {
        id: 'target-2',
        fieldId: 'text-2-1',
        action: Actions.IsVisible,
      },
    ],
  },
  {
    id: 'rule-3',
    name: 'rule 3',
    conditions: [
      [
        {
          id: 'condition-3',
          fieldId: 'text-2-3',
          comparisonOperator: ComparisonOperators.GreaterThan,
          value: '10',
        },
      ],
    ],
    targets: [
      {
        id: 'target-3',
        fieldId: 'text-2-1-3',
        action: Actions.IsVisible,
      },
    ],
  },
  {
    id: 'rule-4',
    name: 'rule 3',
    conditions: [
      [
        {
          id: 'condition-4',
          fieldId: 'check2',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
      ],
    ],
    targets: [
      {
        id: 'target-4',
        fieldId: 'text2',
        action: Actions.IsRequired,
      },
    ],
  },
  {
    id: 'rule-5',
    name: 'rule 3',
    sectionMultipleId: 'SectionMultiple2',
    conditions: [
      [
        {
          id: 'condition-5',
          fieldId: 'check1-mul',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
      ],
    ],
    targets: [
      {
        id: 'target-5',
        fieldId: 'text1-mul',
        action: Actions.IsVisible,
      },
    ],
  },
  {
    id: 'rule-6',
    name: 'rule 3',
    sectionMultipleId: 'SectionMultiple2',
    conditions: [
      [
        {
          id: 'condition-6',
          fieldId: 'check2-mul',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
      ],
    ],
    targets: [
      {
        id: 'target-6',
        fieldId: 'text2-mul',
        action: Actions.IsRequired,
      },
    ],
  },
  {
    id: 'rule-7',
    name: 'rule 3',
    conditions: [
      [
        {
          id: 'condition-7',
          fieldId: 'check3-1',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
      ],
    ],
    targets: [
      {
        id: 'target-7',
        fieldId: 'text3',
        action: Actions.IsVisible,
      },
    ],
  },
  {
    id: 'rule-8',
    name: 'rule 3',
    conditions: [
      [
        {
          id: 'condition-8',
          fieldId: 'check3',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
      ],
    ],
    targets: [
      {
        id: 'target-8',
        fieldId: 'check3-1',
        action: Actions.IsVisible,
      },
    ],
  },
  {
    id: 'rule-9',
    name: 'rule 3',
    conditions: [
      [
        {
          id: 'condition-9',
          fieldId: 'check4-1',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
        {
          id: 'condition-10',
          fieldId: 'check4-2',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
      ],
      [
        {
          id: 'condition-11',
          fieldId: 'check4-3',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
      ],
    ],
    targets: [
      {
        id: 'target-9',
        fieldId: 'text5',
        action: Actions.IsVisible,
      },
    ],
  },
  {
    id: 'rule-10',
    name: 'rule 3',
    conditions: [
      [
        {
          id: 'condition-12',
          fieldId: 'check6',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
      ],
    ],
    targets: [
      {
        id: 'target-10',
        fieldId: 'text6-1',
        action: Actions.IsVisible,
      },
      {
        id: 'target-11',
        fieldId: 'text6-2',
        action: Actions.IsVisible,
      },
    ],
  },
  {
    id: 'rule-11',
    name: 'rule 3',
    sectionMultipleId: 'SectionMultiple4',
    conditions: [
      [
        {
          id: 'condition-13',
          fieldId: 'check4-mul',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
        {
          id: 'condition-14',
          fieldId: 'check7',
          comparisonOperator: ComparisonOperators.IsChecked,
        },
      ],
    ],
    targets: [
      {
        id: 'target-12',
        fieldId: 'text4-mul',
        action: Actions.IsVisible,
      },
    ],
  },
];
